import api from 'service/api'

const guestPortalAPI = api.create('guestPortal')

const get = async (aiInventoryId) =>
  guestPortalAPI.get(`/ai_inventories/${aiInventoryId}/ai_inventory_purposes`)

const create = async (aiInventoryId, data) =>
  guestPortalAPI.post(
    `/ai_inventories/${aiInventoryId}/ai_inventory_purposes`,
    { aiInventoryPurpose: data },
  )

const destroy = async (aiInventoryId, purposeId) =>
  guestPortalAPI.delete(
    `/ai_inventories/${aiInventoryId}/ai_inventory_purposes/${purposeId}`,
  )

export default { get, create, destroy }
